(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-review-proof"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-thermite-reveal-root]:not([data-reveal-ready])');
    if (!roots.length) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = reducedMotion ? null : new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    roots.forEach((root) => {
      root.setAttribute('data-reveal-ready', 'true');
      if (observer) observer.observe(root);
      else root.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thermite-conversion-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stories = document.querySelectorAll('[data-thermite-story]:not([data-story-ready])');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const findTireSearch = () => {
      const explicit = document.querySelector('#thermite-tire-search, [data-tire-search], [id*="blocks_yCJqCK"]');
      if (explicit) return explicit;
      const input = [...document.querySelectorAll('input')].find((node) => /265|tire size|size/i.test(node.placeholder || ''));
      return input ? input.closest('.shopify-section') || input : document.querySelector('main');
    };

    document.querySelectorAll('[data-scroll-to-tire-search]').forEach((link) => {
      if (link.dataset.searchReady) return;
      link.dataset.searchReady = 'true';
      link.addEventListener('click', (event) => {
        const target = findTireSearch();
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(() => target.querySelector('input')?.focus({ preventScroll: true }), reducedMotion ? 0 : 700);
      });
    });

    const revealObserver = reducedMotion ? null : new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: .1 });

    stories.forEach((story) => {
      story.dataset.storyReady = 'true';
      story.querySelectorAll('[data-story-reveal]').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));

      if (!reducedMotion) {
        story.addEventListener('pointermove', (event) => {
          const rect = story.getBoundingClientRect();
          story.style.setProperty('--mouse-x', `${event.clientX - rect.left}px`);
          story.style.setProperty('--mouse-y', `${event.clientY - rect.top}px`);
        }, { passive: true });
      }

      const stage = story.querySelector('[data-story-stage]');
      const scene = story.querySelector('[data-morph-scene]');
      const progress = story.querySelector('[data-story-progress]');
      const hudMode = story.querySelector('[data-hud-mode]');
      const finalScene = story.querySelector('[data-final-scene]');
      let targetMorph = 0;
      let displayedMorph = 0;
      let animationFrame = 0;

      const clamp01 = (value) => Math.min(Math.max(value, 0), 1);
      const smoothstep = (edge0, edge1, value) => {
        const x = clamp01((value - edge0) / Math.max(edge1 - edge0, .0001));
        return x * x * (3 - 2 * x);
      };

      const readScroll = () => {
        if (reducedMotion || !stage || !scene) return;
        const rect = stage.getBoundingClientRect();
        const travel = Math.max(stage.offsetHeight - window.innerHeight, 1);
        targetMorph = clamp01(-rect.top / travel);
        if (!animationFrame) animationFrame = requestAnimationFrame(renderMorph);
      };

      const renderMorph = () => {
        animationFrame = 0;
        displayedMorph += (targetMorph - displayedMorph) * .115;
        if (Math.abs(targetMorph - displayedMorph) < .0008) displayedMorph = targetMorph;

        const eased = smoothstep(0, 1, displayedMorph);
        const carReveal = smoothstep(.2, .72, displayedMorph);
        const tireVisibility = 1 - smoothstep(.26, .69, displayedMorph);

        scene.style.setProperty('--morph', displayedMorph.toFixed(4));
        scene.style.setProperty('--morph-eased', eased.toFixed(4));
        scene.style.setProperty('--car-reveal', carReveal.toFixed(4));
        scene.style.setProperty('--tire-visibility', tireVisibility.toFixed(4));
        progress?.style.setProperty('--story-progress', eased.toFixed(4));

        if (hudMode) {
          hudMode.textContent = displayedMorph < .3 ? 'STREET MODE' : displayedMorph < .62 ? '2JZ LOADING' : 'BURNOUT MODE';
        }

        if (finalScene) {
          const finalRect = finalScene.getBoundingClientRect();
          const finalAmount = clamp01((window.innerHeight - finalRect.top) / (window.innerHeight + finalRect.height));
          const finalEased = smoothstep(0, 1, finalAmount);
          finalScene.style.setProperty('--final-car-x', `${(1 - finalEased) * 175}px`);
          finalScene.style.setProperty('--final-car-scale', `${.91 + finalEased * .09}`);
        }

        if (Math.abs(targetMorph - displayedMorph) >= .0008) {
          animationFrame = requestAnimationFrame(renderMorph);
        }
      };

      readScroll();
      window.addEventListener('scroll', readScroll, { passive: true });
      window.addEventListener('resize', readScroll, { passive: true });

      const accordions = story.querySelectorAll('.thermite-accordion');
      accordions.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          accordions.forEach((other) => { if (other !== item) other.open = false; });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
